import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { exitMissionAction } from '../../../redux/screen/exitmission';


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function ExitPopup({open,setOpen,missionId}) {
const dispatch=useDispatch()
const navigate=useNavigate()


 

  const handleClose = () => {
    setOpen(false);
  };
  const handleExit=async()=>{
    const exit=await dispatch(exitMissionAction(missionId))
    if(exit.payload.status===201){
    localStorage.removeItem("mission_id")

        setOpen(false)
        navigate('/home')
    }
    
  }

  return (
    <div>
      
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
        className='mobile__width'
        
        
      >
        <DialogTitle>{"Exit?"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            Are you sure you want to exit from this mission?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Disagree</Button>
          <Button onClick={handleExit}>Agree</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
